import { DisplaySelection } from '../models/DisplaySelection';
import { SessionManagementService } from './SessionManagementService';

export const LocalStorageDisplayKeyPrefix = 'displayMode';

export class LocalStorageService {
  public static instance = new LocalStorageService();

  public setLocalDisplayView(value: DisplaySelection) {
    localStorage.setItem(this.getLocalDisplayKey(), value.name);
  }

  public getLocalDisplayView(key: string): string | null {
    return localStorage.getItem(key);
  }

  public getLocalDisplayKey() {
    return `${LocalStorageDisplayKeyPrefix}-${SessionManagementService.instance.sessionUserId()}`;
  }
}
